// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-select[data-v-2514e023]{position:absolute;top:1px;left:1px;border-radius:10px 0 0 10px!important;z-index:1}.indent[data-v-2514e023]{padding-left:50px!important}[data-v-2514e023] .text-input-wrapper{border-radius:10px!important;min-height:unset!important;min-height:var(--textHeight)!important}[data-v-2514e023] .text-input-wrapper #vue-editor-wrapper{min-height:var(--editorHeight)!important}", ""]);
// Exports
module.exports = exports;
